exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-table .pagination-wrap{text-align:center}.sc-table .action-list{text-align:center}.sc-table .action-list>span+span{margin-left:10px}\n", ""]);

// exports
